import * as React from "react";
import {
  IContentPaginationProps,
  IContentPaginationState,
} from "./ContentPagination.types";
import { Pagination } from "./Pagination";

/**
 * This component takes in data and renders it in a paginated structure. It is possible to customize it to some extent by its props, see [[IContentPaginationProps]].
 */ const paginationSession = "pagination_session";
export class ContentPagination extends React.Component<
  IContentPaginationProps,
  IContentPaginationState
> {
  constructor(props: IContentPaginationProps) {
    super(props);

    this.state = {
      activeStep: 1,
    };
  }

  static defaultProps = {
    onStepChange: {},
    nextLabel: "Nästa",
    previousLabel: "Föregående",
    pageSize: 10,
    showPreviousOnFirstPage: true,
    showNextOnLastPage: true,
    onChangePageCb: () => {},
    visiblePages: 10,
  };

  private changePage = (pageId: number) => {
    this.setState(
      {
        activeStep: pageId,
      },
      () => {
        this.props.onChangePageCb(pageId);
      }
    );
    if (this.props.useSessionStorage) {
      sessionStorage.setItem(paginationSession, JSON.stringify(pageId));
    }
  };

  componentWillReceiveProps() {
    if (
      this.props.useSessionStorage &&
      typeof window !== "undefined" &&
      sessionStorage.getItem(paginationSession) != undefined &&
      sessionStorage.getItem(paginationSession) != "{}"
    ) {
      const sessionState: number = JSON.parse(
        sessionStorage.getItem(paginationSession)
      );
      this.setState({
        activeStep: sessionState,
      });
    }
  }

  componentDidMount() {
    if (
      this.props.useSessionStorage &&
      typeof window !== "undefined" &&
      sessionStorage.getItem(paginationSession) != undefined &&
      sessionStorage.getItem(paginationSession) != "{}"
    ) {
      const sessionState: number = JSON.parse(
        sessionStorage.getItem(paginationSession)
      );
      this.setState({
        activeStep: sessionState,
      });
    }
  }
  private renderData = () => {
    const { data, pageSize } = this.props;
    const { activeStep } = this.state;
    const pageCount = Math.ceil(data.length / pageSize);
    // step can't be greater than pagecount. reset to 1 if pagecount changes.
    const step = activeStep <= pageCount ? activeStep : 1;
    const startIndex = step * pageSize - pageSize;
    return data.slice(startIndex, startIndex + pageSize);
  };

  public render() {
    const {
      nextLabel,
      previousLabel,
      data,
      pageSize,
      noResultText,
      showPreviousOnFirstPage,
      showNextOnLastPage,
    } = this.props;
    const { activeStep } = this.state;
    const pageCount = this.props.pageCount || Math.ceil(data.length / pageSize);

    return (
      <React.Fragment>
        <ul className="search-list__result-new">
          {this.props.pageCount > 0 && this.props.data}
          {!this.props.pageCount && data && this.renderData()}
        </ul>
        {data && data.length > 0 && (
          <Pagination
            steps={pageCount}
            activeStep={activeStep <= pageCount ? activeStep : 1}
            onStepChangeCb={this.changePage}
            nextLabel={nextLabel}
            previousLabel={previousLabel}
            showNextOnLastPage={showNextOnLastPage}
            showPreviousOnFirstPage={showPreviousOnFirstPage}
            visiblePages={this.props.visiblePages}
          />
        )}
        {!data ||
          (data.length === 0 && (
            <p className="search-result__no-results">{noResultText}</p>
          ))}
      </React.Fragment>
    );
  }
}
